<template lang="pug">
  app-dialog(v-model="$_show" header="Выбрать период" @confirm="addHoliday()" confirmText="Добавить" :confirm-disabled="!ready")
    app-date-picker(v-model="form.holiday.startDate" :max="form.holiday.endDate" format="YYYY-MM-DD" :viewFormat="'DD.MM.YYYY'" label="Начало периода")
    app-date-picker(v-model="form.holiday.endDate" :min="form.holiday.startDate" format="YYYY-MM-DD" :viewFormat="'DD.MM.YYYY'" label="Конец периода")
    app-select(v-model="form.holiday.holidayType" label="Отпуск/больничный" :items="holidayTypes" item-text="title" return-object)
</template>

<script>
import { AppDialogToggable } from '@/components'
import { judgeService } from "@/_services";
import { mapState, mapGetters, mapMutations } from 'vuex'

let defaultHoliday = {
  startDate: null,
  endDate: null,
  holidayType: '',
  id: ''
}

export default {
  mixins: [AppDialogToggable],

  props: {
    holiday: Object
  },

  watch: {
    $_show (value) {
      if (value) {
        this.form.holiday = this.holiday ? this.holiday : Object.assign({}, defaultHoliday)
      }
    }
  },

  computed: {
    ...mapState('judgeReestr', ['currentJudge']),
    ...mapGetters('judgeReestr', ['holidayTypes']),

    ready () {
      if (this.form.holiday.startDate && this.form.holiday.endDate && this.form.holiday.holidayType) return true
      return false
    },
  },

  methods: {
    ...mapMutations('judgeReestr', ['setJudgeInJudges']),

    addHoliday () {
      judgeService.addHoliday(this.form.holiday).then(data => {
        if (this.currentJudge.holiday.find(item => item.id === data.id))
          this.currentJudge.holiday = this.currentJudge.holiday.filter(cat => data.id != cat.id )
        this.currentJudge.holiday.push(data)
        this.updateJudge()
      })
    },

    updateJudge () {
      this.currentJudge.signImage = ''
      judgeService.updateJudge(this.currentJudge).then(data => this.setJudgeInJudges(data))
      return true
    }
  },

  data () {
    return {
      form: { 
        holiday: defaultHoliday
      }
    }
  }
}
</script>